import get from "lodash/get";

function currentDeviceSelector(state) {
  return get(state, "pages.currentDevice.device", null);
}

export { currentDeviceSelector };
